module.exports = __webpack_public_path__ + "media/images/shinagawa-cropped-f9283d1ae3799fdb666d2af99eee1ce6.png";